import { useRecoilValue } from "recoil";
import { userPromotionAtom } from "recoil/userPromotionAtom";
import useGoogleLoginV2 from "../../hooks/useGoogleLoginV2";
import LoginButtonTemplatePromotion from "./LoginButtonTemplatePromotion";
import useAutoLoginPromotion from "../../hooks/useAutoLoginPromotion";

export default function GoogleLoginButtonPromotion({
  render,
}: {
  render?: (props: {
    onClick: (e?: any) => void;
    disabled?: boolean;
  }) => JSX.Element;
}) {
  useAutoLoginPromotion();
  const user = useRecoilValue(userPromotionAtom);
  const { handleGoogleLogin, isLoading } = useGoogleLoginV2();

  return (
    <LoginButtonTemplatePromotion
      loginType="google"
      action={handleGoogleLogin}
      isLoggedIn={!!user?.accessToken}
      isLoading={isLoading}
    />
  );
}
